<div class="container">
  <div class="loader"></div>
  <div class="text">loading...</div>
</div>
